import * as yup from 'yup'
import mapValues from 'lodash/mapValues'

export function selectChannelsValidationSchema(): yup.AnyObjectSchema {
  return yup
    .object()
    .shape({
      channels: yup.lazy((obj) =>
        yup
          .object(mapValues(obj, () => yup.boolean()))
          .test('testName', 'errorMessage', (obj) => {
            return (
              Boolean(obj) && Object.keys(obj).some((key) => obj[key] === true)
            )
          })
      ),
    })
    .required()
}
